import {BaseView} from '../core/view';
export default BaseView.extend({

    elems: {
        tabPanes: null,
        tabLinks: null,
        tabNav: null
    },

    events: {
        "click .js-tab-link": "onTabActivate",
        "click .js-tab-dismiss": "onTabDeactivate"
    },

    states: {
        tabLinkActive:  'tab-link--active',
        tabPaneActive:  'tab-pane--active',
        tabPanesActive: 'tab-panes--active',
        tabLoaded:      'tabs--loaded'
    },

    initialize: function () {
        this.elems.tabLinks =   this.el.querySelector('.js-tab-links');
        this.elems.tabPanes =   this.el.querySelector('.js-tab-panes');
        this.elems.tabNav =     this.el.querySelector('.js-tab-nav');
        window.addEventListener('resize', this.adaptComponentBehaviour.bind(this));
        this.adaptComponentBehaviour();
        this.el.classList.add(this.states.tabLoaded);
    },

    onTabActivate: function(e) {
        this.resetComponentState();
        let targetId = e.target.getAttribute('data-target');
        let targetElem = this.elems.tabPanes.querySelector(targetId);
        e.target.classList.add(this.states.tabLinkActive);
        targetElem.classList.add(this.states.tabPaneActive);
        this.elems.tabPanes.classList.add(this.states.tabPanesActive);
        this.adaptComponentHeight(true);
    },

    onTabDeactivate: function() {
        this.elems.tabPanes.classList.remove(this.states.tabPanesActive);
        this.adaptComponentHeight(false);
    },

    resetComponentState: function() {
        let tabs = this.elems.tabLinks.querySelectorAll(`.${this.states.tabLinkActive}`);
        [...tabs].forEach(tab => tab.classList.remove(this.states.tabLinkActive));
        let panes = this.elems.tabPanes.querySelectorAll(`.${this.states.tabPaneActive}`);
        [...panes].forEach(pane => pane.classList.remove(this.states.tabPaneActive));
    },
    
    adaptComponentHeight: function(isPaneActive) {
        let tabNavHeight = this.elems.tabNav.offsetHeight;
        let tabPanesHeight = this.elems.tabPanes.offsetHeight;
        let isBehaviorDefault = this.el.classList.contains('tab--default');
        let componentHeight = isBehaviorDefault ? "initial" :
            `${isPaneActive ? tabPanesHeight : tabNavHeight}px`;
        this.el.style.height = componentHeight;
    },

    adaptComponentBehaviour: function() {
        if (this.el.offsetWidth > 900) { 
            this.el.classList.add('tab--default');
            this.el.classList.remove('tab--mobile'); 
        } else { 
            this.el.classList.add('tab--mobile'); 
            this.el.classList.remove('tab--default'); 
        }

        let isPaneActive = this.elems.tabPanes.classList.contains(this.states.tabPanesActive);
        this.adaptComponentHeight(isPaneActive);
    }
});